import {AfterViewInit, Component, EventEmitter, Inject, Input, Output, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {SubscribedComponent} from "../../subscribed.component";
import {NbComponentOrCustomStatus, NbPopoverDirective} from "@nebular/theme";

export interface DMenuItem<T>{
  action?: (data: T, m: DMenuItem<T>, i: number) => void,
  link?: string,
  title: string,
  titlefill?: any,
  disabled?: boolean,
  icon?: string,
  status?: NbComponentOrCustomStatus,
  hidden?: boolean|((data: T, m: DMenuItem<T>, i: number) => boolean)
}

@Component({
    selector: 'bst-menu-dialog',
    templateUrl: './menu-dialog.component.html',
    styleUrls: ['./menu-dialog.component.scss'],
    standalone: false
})
export class MenuDialogComponent<T> extends SubscribedComponent implements AfterViewInit{

  @ViewChild(NbPopoverDirective) public popover: NbPopoverDirective;

  @Input() disabled: boolean = false;
  @Input() menu: DMenuItem<T>[] = [];
  @Input() data: T = undefined;

  @Output() openChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private router: Router) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    if(this.popover) {
      this.subs.push(this.popover.nbPopoverShowStateChange.subscribe((o) => {
        this.openChanged.emit(o.isShown);
      }));
    }
  }

  clicked(m: DMenuItem<T>, i: number) {
    if(m.action && typeof m.action === 'function'){
      m.action(this.data, m, i);
    }
    else if(m.link){
      this.router.navigateByUrl(m.link);
    }
    return this.popover.hide();
  }

  isHidden(m: DMenuItem<T>, index: number) {
    return m.hidden && (typeof m.hidden !== 'function' || m.hidden(this.data, m, index));
  }

  get filtered(): DMenuItem<T>[]{
    return this.menu.filter((m, i) => !this.isHidden(m, i));
  }
}
